import React from 'react';
import { CheckCircle } from 'lucide-react';

interface InstantScanFeedbackProps {
  isVisible: boolean;
}

export function InstantScanFeedback({ isVisible }: InstantScanFeedbackProps) {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center pointer-events-none">
      <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-6 animate-fade-in">
        <div className="flex flex-col items-center gap-3">
          <CheckCircle className="w-12 h-12 text-green-500 animate-scale-in" />
          <p className="text-lg font-medium text-gray-900">Scan successful!</p>
        </div>
      </div>
    </div>
  );
}
